module.exports = __webpack_public_path__ + "img/pencil.711fc426.svg";